<template>
  <div class="media">
    <Button
      class="add-button"
      type="primary"
      icon="md-add"
      size="large"
      @click="add"
    >
      添加媒体
    </Button>
    <Form
      ref="mediaForm"
      :model="editMedia"
      :rules="rules"
    >
      <Table
        :columns="columns"
        :data="pageMediaList"
        size="large"
        stripe
      >
        <template
          slot="name"
          slot-scope="{ row: { id, media_name } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="media_name"
          >
            <iInput
              v-model="editMedia.media_name"
              size="large"
              :autofocus="true"
            />
          </FormItem>
          <p
            v-else
            v-text="media_name"
          />
        </template>
        <template
          slot="description"
          slot-scope="{ row: { id, media_description } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="media_description"
          >
            <iInput
              v-model="editMedia.media_description"
              type="textarea"
              :autosize="true"
              size="large"
            />
          </FormItem>
          <p
            v-else
            v-text="media_description"
          />
        </template>
        <template
          slot="platform"
          slot-scope="{ row: { id, platform_type } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="platform_type"
          >
            <RadioGroup
              v-model="editMedia.platform_type"
              size="large"
            >
              <Radio
                :label="0"
                :true-value="0"
                :disabled="!!id"
              >
                <span>
                  IOS
                </span>
              </Radio>
              <Radio
                :label="1"
                :true-value="1"
                :disabled="!!id"
              >
                <span>
                  安卓
                </span>
              </Radio>
            </RadioGroup>
          </FormItem>
          <p
            v-else
            v-text="platform_type ? '安卓' : 'IOS'"
          />
        </template>
        <template
          slot="status"
          slot-scope="{ row: { id, status } }"
        >
          <iSwitch
            v-if="editId === id"
            v-model="editMedia.status"
            size="large"
            :true-value="1"
            :false-value="0"
          >
            <span slot="open">
              打开
            </span>
            <span slot="close">
              关闭
            </span>
          </iSwitch>
          <p
            v-else
            v-text="status ? '打开' : '关闭'"
          />
        </template>
        <template
          slot="timeout"
          slot-scope="{ row: { id, timeout } }"
        >
          <FormItem
            v-if="editId === id"
            class="form-item"
            prop="timeout"
          >
            <iInput
              v-model="editMedia.timeout"
              size="large"
              :autofocus="true"
            />
          </FormItem>
          <p
            v-else
            v-text="timeout || '-'"
          />
        </template>
        <template
          slot="edit"
          slot-scope="{ row }"
        >
          <div v-if="editId === row.id">
            <Button
              v-if="row.id"
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitEdit"
            />
            <Button
              v-else
              class="operation"
              type="primary"
              icon="md-checkmark"
              @click="submitAdd"
            />
            <Button
              v-if="row.id"
              class="operation"
              icon="md-close"
              @click="cancelEdit"
            />
            <Button
              v-else
              class="operation"
              icon="md-trash"
              @click="cancelAdd"
            />
            <Poptip
              confirm
              transfer
              title="确定要删除吗？"
              ok-text="删除"
              cancel-text="取消"
              @on-ok="deleteMedia({ media: row })"
            >
              <Button
                v-if="row.id"
                class="operation delete"
                type="error"
                icon="md-trash"
              />
            </Poptip>
          </div>
          <div v-else>
            <Button
              class="operation"
              icon="md-create"
              @click="edit({ media: Object.assign({}, row) })"
            />
          </div>
        </template>
      </Table>
      <template v-if="total > 10">
        <Page
          class-name="pager"
          :total="total"
          :current="current"
          @on-change="pageChanged"
        />
      </template>
    </Form>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { Table, Button, Input, RadioGroup, Radio, Switch, Form, FormItem, Poptip, Page } from 'iview'

export default {
  components: {
    Table,
    Button,
    iInput: Input,
    RadioGroup,
    Radio,
    iSwitch: Switch,
    Form,
    FormItem,
    Poptip,
    Page
  },

  data () {
    return {
      columns: [
        { title: '媒体ID', key: 'id', width: 80 },
        { title: '媒体名', slot: 'name' },
        { title: '媒体描述', slot: 'description' },
        { title: '平台', slot: 'platform' },
        { title: '超时时间(ms)', slot: 'timeout' },
        { title: '状态', slot: 'status' },
        { title: '操作', slot: 'edit', width: 160 }
      ],

      rules: {
        media_name: [
          { required: true, message: '请填写媒体名称' }
        ],
        media_description: [
          { required: true, message: '请填写媒体描述' }
        ],
        platform_type: [
          { required: true, message: '请选择平台' }
        ]
      }
    }
  },

  computed: {
    ...mapState('media', [
      'pageMediaList',
      'total',
      'current',
      'editId',
      'editMedia'
    ])
  },

  created () {
    this.getList({ current: this.current })
  },

  methods: {
    ...mapMutations('media', [
      'add',
      'cancelAdd',
      'edit',
      'cancelEdit'
    ]),

    ...mapActions('media', {
      getList: 'getList',
      deleteMedia: 'delete',
      submitAdd (dispatch) {
        this.$refs.mediaForm.validate(isValid => {
          if (isValid) {
            dispatch('submitAdd')
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      },

      submitEdit (dispatch) {
        this.$refs.mediaForm.validate(isValid => {
          if (isValid) {
            dispatch('submitEdit')
          } else {
            this.$Message.error('填写信息有误！')
          }
        })
      }
    }),

    pageChanged (page) {
      this.getList({ current: page })
    }
  }
}
</script>

<style lang="less" scoped>
.add-button {
  margin-bottom: 10px;
}
button.operation {
  margin-right: 5px;
  padding: 0;
  width: 33px;
  height: 33px;
  font-size: 16px;

  &:last-child {
    margin-right: 0;
  }

  &.delete {
    margin-left: 15px;
  }
}
.form-item {
  margin-top: 24px;
}
.pager {
  margin-top: 16px;
  text-align: center;
}
</style>
